var _defs, _style, _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAstrotekText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 338 296",
    width: 338,
    height: 296,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Atrotek combo mark-01-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(226.34,0,0,196.02,52.75,110.59)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#383845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20212a"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #8fd6e7 } \n\t\t.s1 { fill: url(#g1);stroke: #8fd6e7;stroke-miterlimit:10;stroke-width: 10 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m1.9 291.9l13.4-60.9h16.5l13.3 60.9h-11.8l-2.6-13.3h-14.5l-2.8 13.3c0 0-11.5 0-11.5 0zm16-22.8h10.9l-5.1-26.8h-0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m65.7 292.6q-2.5 0-5.4-0.2-2.8-0.2-5.6-0.5-2.7-0.4-4.9-0.7v-9.2q2.6 0.2 4.9 0.4 2.2 0.2 4.2 0.3 1.9 0.1 3.3 0.1 2.9 0 4.7-0.3 1.8-0.3 2.7-1.3 0.6-0.7 0.9-1.7 0.3-1 0.4-2.2 0.1-1.2 0.1-2.6 0-2.4-0.2-3.9-0.2-1.5-0.7-2.3-0.6-0.8-1.9-1.3-1.3-0.5-3.6-0.9l-8.7-1.5q-2.1-0.4-3.5-1.6-1.4-1.2-2.3-3.2-0.9-2-1.2-4.9-0.4-3-0.4-6.9 0-5.4 1.3-8.9 1.2-3.5 3.4-5.4 2.3-2 5.6-2.8 3.3-0.8 7.4-0.8 2.7 0 5.4 0.3 2.6 0.2 4.9 0.5 2.3 0.3 3.8 0.7v9.2q-1.9-0.4-3.8-0.5-1.9-0.2-3.8-0.3-1.8 0-3.7 0-3-0.1-4.8 0.3-1.7 0.3-2.6 1.2-0.9 0.9-1.2 2.3-0.2 1.5-0.2 3.9c0 1.7 0 3.1 0.2 4q0.1 1.4 1.1 2.1 1 0.7 3.1 1.1l7.9 1.4q2.3 0.4 3.9 1.1 1.7 0.7 2.9 2 1.2 1.2 2 3.4 0.5 1.1 0.7 2.7 0.3 1.5 0.4 3.4 0.2 1.9 0.2 4.1 0 4.6-0.6 7.9-0.6 3.4-1.9 5.6-1.3 2.2-3.3 3.5-1.9 1.2-4.7 1.8-2.8 0.6-6.4 0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m98.1 291.9v-50.8h-11.9v-10.1h35.4v10.1h-11.9v50.8h-11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m127.3 291.9v-60.9h20.5q5.1 0 8.1 1.3 3.1 1.3 4.6 3.9 1.6 2.5 2.1 6.1 0.4 3.6 0.4 8.2 0.1 3.6-0.4 7-0.4 3.4-1.7 6.1-1.3 2.6-4 4.1l7.4 24.2h-12l-6.2-22q-0.4 0-0.7 0h-6.5v22c0 0-11.6 0-11.6 0zm18.8-22q0.5-0.1 0.9-0.1 0.7-0.1 1.2-0.2l-2.5-1.1zm-7.2-9.4h6q2.3 0 3.5-0.5 1.3-0.5 2-1.6 0.6-1.1 0.8-3 0.2-2 0.2-4.7 0-3-0.2-4.9-0.2-1.9-0.8-2.9-0.6-1.1-1.9-1.6-1.3-0.4-3.6-0.5h-6c0 0 0 19.7 0 19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m189.1 292.6q-5.1 0-8.5-0.6-3.4-0.6-5.5-2.5-2.1-1.8-3.2-5.2-1.1-3.5-1.5-9-0.4-5.6-0.4-13.8 0-8.3 0.4-13.8 0.4-5.6 1.5-9.1 1.2-3.4 3.2-5.2 2.1-1.8 5.5-2.4 3.4-0.7 8.5-0.7c3.3 0 6 0.2 8.3 0.7q3.4 0.6 5.5 2.4 2.2 1.8 3.3 5.2 1.1 3.5 1.5 9.1 0.4 5.5 0.4 13.8 0 8.2-0.4 13.8-0.4 5.5-1.5 9-1.1 3.4-3.3 5.2-2.1 1.9-5.5 2.5-3.4 0.6-8.3 0.6zm0-9.8q2 0 3.3-0.3 1.4-0.3 2.3-1.3 0.8-1.1 1.1-3.4 0.4-2.3 0.5-6.3 0.1-3.9 0.1-10.1 0-6.1-0.1-10-0.1-4-0.5-6.3-0.3-2.3-1.1-3.4-0.9-1-2.3-1.3-1.3-0.3-3.3-0.3c-1.4 0-2.6 0.1-3.5 0.3q-1.3 0.3-2.1 1.3-0.8 1.1-1.2 3.4-0.4 2.3-0.5 6.3-0.1 3.9-0.1 10 0 6.2 0.1 10.1 0.1 4 0.5 6.3 0.4 2.3 1.2 3.4 0.8 1 2.1 1.3 1.3 0.3 3.5 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m224.5 291.9v-50.8h-11.8v-10.1h35.3v10.1h-11.8v50.8c0 0-11.7 0-11.7 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m253.8 291.9v-60.9h29.9v9.9h-18.3v15.4h15.8v9.7h-15.8v16.1h18.3v9.8h-29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m291.6 291.9v-60.9h11.6v25.1h3.8l10.6-25.1h12.1l-13.3 29.2 13.5 31.7h-12.5l-10.4-25.9h-3.8v25.9z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m222.5 12.6h-113.2l-56.5 98 56.5 98h113.2l56.6-98-56.6-98z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m198.1 34.4h-64.3l-45.2 78.3 37.9 69.1v-40.3l8.3-15.5 49.6-0.8-13.5-25.3h-28.6l23.6-44.3 39.3 73.9 0.2 48.7 37.9-65.5-45.2-78.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstrotekText);
export default __webpack_public_path__ + "static/media/astrotek-text.84bc805783384d52bdc7164aa33ec3fa.svg";
export { ForwardRef as ReactComponent };